export default "__VITE_ASSET__l1c_GU2F__"